import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { HtmlEditor, TableContextMenu, TableResizing } from 'devextreme-react/html-editor';
import { Button, Header, List, Segment, Table, Image, Grid, GridColumn, Checkbox, Modal } from 'semantic-ui-react';
import { Consts, Theme } from '../../../../res';
import ErrorSegment from '../../../Operantinals/ErrorSegment';
import VideoPlayer from '../../../Generals/VideoPlayer';

const McqsQuestionTemplate = ({ Q, onAnswerQuestion, t, isViewOnly, onExcludeOption }) => {
    const studentAnswer = Q.answerOptionId;
    const correctAnswerOptionId = Q.correctAnswer.correctAnswerOptionId;
    const showAnswers = Q.isSubmited || isViewOnly;
    const alphArray = [t('A'), t('B'), t('C'), t('D')];
    const [showExplanation, setShowExplanation] = useState(false);


    const renderOptionExplanations = () => {
        if (showAnswers) return (
            <div className='tw-p-5 tw-bg-PRIMARY_2'>
                <div className='tw-flex tw-flex-row tw-items-center tw-justify-between'>
                    <div>
                        <Header as='h4' style={{ color: Theme.colors.CPA_NAVY }}>{t('Explanations')}</Header>
                    </div>

                    {Q && Boolean(Q?.correctAnswer?.explanations?.videos?.length) && <div>
                        <Button icon="film" onClick={() => setShowExplanation(true)} content={t("SkillBuilderVideo")} style={{ backgroundColor: Theme.colors.CPA_NAVY, color: Theme.colors.WHITE }} />
                    </div>}
                </div>
                <List relaxed='very' verticalAlign='middle'>
                    {
                        Q.options.filter(op => isViewOnly ? op.id === correctAnswerOptionId : true).map((o, indx) => <List.Item
                            key={o.id}
                            style={{ color: o.id === correctAnswerOptionId ? 'green' : 'red' }}
                            content={
                                <Grid stackable verticalAlign='top' columns='2'>
                                    <GridColumn width='1' >
                                        {`${alphArray[indx]}.`}
                                    </GridColumn>

                                    <GridColumn width='15'>
                                        {o.explanation.trim() ?
                                            <HtmlEditor value={o.explanation.trim()} readOnly >
                                                <TableContextMenu enabled />
                                                <TableResizing enabled />
                                            </HtmlEditor>
                                            : (o.id === correctAnswerOptionId ? t('CorrectAnswer') : t('NoExplanation'))
                                        }
                                    </GridColumn>
                                </Grid>
                            }
                        />)
                    }
                </List>
                {
                    Q.correctAnswer.explanations.imgs.map(i => <Image loading="lazy" key={i.url} src={i.url} size='large' rounded />)
                }
            </div>
        );
    };

    return (
        <Segment basic style={{ minHeight: '40vh', fontSize: '14px' }}>
            <Table basic='very' unstackable definition collapsing>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell style={{ border: 'none' }} />
                        <Table.HeaderCell style={{ border: 'none' }} />
                        {
                            Q.options[0].contents.length > 1 &&
                            Q.options[0].contents.map(col => <Table.HeaderCell key={col.columnId} style={{ border: 'none' }}>{col.colName.trim()}</Table.HeaderCell>)
                        }
                    </Table.Row>
                </Table.Header>

                <Table.Body>

                    {
                        Q.options.map((o, indx) => <Table.Row
                            key={o.id}
                            onContextMenu={() => onExcludeOption(Q, o.id)}
                        // negative={showAnswers && o.id !== correctAnswerOptionId}
                        // positive={showAnswers && o.id === correctAnswerOptionId}
                        >
                            <Table.Cell
                                style={{ cursor: 'pointer', backgroundColor: 'white', border: 'none' }}
                                onClick={() => Q.isSubmited ? null : onAnswerQuestion({ ...Q, answerOptionId: o.id }, true)}
                                collapsing
                            >
                                <Checkbox
                                    radio
                                    checked={studentAnswer === o.id}
                                    style={{ transform: 'scale(1.5)' }}
                                />
                            </Table.Cell>

                            <Table.Cell style={{ border: 'none', textDecoration: o.isExcluded && "line-through" }} collapsing>
                                {alphArray[indx]}.
                            </Table.Cell>

                            {
                                o.contents.map(col => <Table.Cell key={`${o.id}${col.columnId}`} style={{ border: 'none', backgroundColor: studentAnswer === o.id && Q.isSubmited ? correctAnswerOptionId === studentAnswer ? "green" : "yellow" : 'transparent', textDecoration: o.isExcluded && "line-through" }} >
                                    {col.content.trim()}
                                </Table.Cell>
                                )
                            }
                        </Table.Row>)
                    }

                </Table.Body>
            </Table>

            {renderOptionExplanations()}

            <Modal
                onClose={() => setShowExplanation(false)}
                open={showExplanation}
                content={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? <VideoPlayer kind={Consts.VIDEOS_KINDS.EXPLANATION} videoDetails={{ ...Q.correctAnswer.explanations.videos[0], ...Q }} onClose={() => setShowExplanation(false)} /> : <ErrorSegment text={t('ComingSoon')} icon='wait' />}
                basic={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? true : false}
                size='large'
                centered
                closeIcon={!(Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length)}
                closeOnDimmerClick={false}
            />

        </Segment>
    );
};

export default withTranslation()(McqsQuestionTemplate);